import Joi from '@hapi/joi'

export const CardActivateFilteringSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
        "any.required": `Operation Entity required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Collection Point required`,
        "any.required": `Collection Point required`
    })
}